import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Link } from "react-router-dom";
import { X } from "lucide-react";
import { updateConsent } from "@/lib/analytics";

export function CookieConsent() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie-consent");
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookie-consent", "accepted");
    updateConsent(true);
    setShowBanner(false);
  };

  const handleReject = () => {
    localStorage.setItem("cookie-consent", "rejected");
    updateConsent(false);
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 animate-in slide-in-from-bottom-5">
      <Card className="mx-auto max-w-4xl border-2 border-primary/20 bg-card/95 backdrop-blur-sm p-6 shadow-lg">
        <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
          <div className="flex-1">
            <h3 className="font-semibold text-lg mb-2">Vi använder cookies</h3>
            <p className="text-sm text-muted-foreground">
              Vi använder nödvändiga cookies för att webbplatsen ska fungera korrekt. 
              Genom att klicka "Acceptera alla" godkänner du även användning av cookies för analys och förbättring av tjänsten.{" "}
              <Link to="/cookies" className="underline hover:text-primary">
                Läs mer om cookies
              </Link>
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-2">
            <Button variant="outline" onClick={handleReject}>
              Endast nödvändiga
            </Button>
            <Button onClick={handleAccept}>
              Acceptera alla
            </Button>
          </div>
        </div>
      </Card>
    </div>
  );
}
